export default __webpack_public_path__ + "static/media/httpswww.youtube.comwatchv=8hpXkniByp0&ab_channel=Granty.b19011b3.jpg";